var _defs, _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    zoomAndPan: "magnify",
    viewBox: "0 0 810 809.999993",
    height: 1080,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    id: "a80a8add91"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0",
    colorInterpolationFilters: "sRGB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "2a8743b127"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a80a8add91)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -81,
    width: 972,
    fill: "#000000",
    y: -80.999999,
    height: 971.999992,
    fillOpacity: 0.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "d247666f69"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1 1 L 649 1 L 649 649 L 1 649 Z M 1 1 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "89fdfa2056"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 325 1 C 146.058594 1 1 146.058594 1 325 C 1 503.941406 146.058594 649 325 649 C 503.941406 649 649 503.941406 649 325 C 649 146.058594 503.941406 1 325 1 Z M 325 1 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dd06b767f8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 650,
    y: 0,
    height: 650
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "84bef824b4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 478 268.0625 L 676.832031 268.0625 L 676.832031 541.8125 L 478 541.8125 Z M 478 268.0625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aab9c37f4b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 305 268.0625 L 504 268.0625 L 504 541.8125 L 305 541.8125 Z M 305 268.0625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "53f6bb20cf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 133.164062 268.0625 L 332 268.0625 L 332 541.8125 L 133.164062 541.8125 Z M 133.164062 268.0625 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#2a8743b127)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 80, 80)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dd06b767f8)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d247666f69)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#89fdfa2056)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M 1 1 L 649 1 L 649 649 L 1 649 Z M 1 1 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#84bef824b4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7abf5b",
    d: "M 676.523438 541.929688 L 579.257812 541.929688 L 478.6875 403.902344 L 579.292969 268.0625 L 676.59375 268.0625 L 582.6875 405.410156 Z M 676.523438 541.929688 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aab9c37f4b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5b792e",
    d: "M 409.390625 405.410156 L 503.261719 268.0625 L 406 268.0625 L 305.425781 403.902344 L 405.960938 541.929688 L 503.191406 541.929688 Z M 409.390625 405.410156 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#53f6bb20cf)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#292929",
    d: "M 237.367188 405.410156 L 331.238281 268.0625 L 233.976562 268.0625 L 133.402344 403.902344 L 233.9375 541.929688 L 331.167969 541.929688 Z M 237.367188 405.410156 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrows);
export default __webpack_public_path__ + "static/media/LeftArrows.dd786d8c2128f41ffeb09e63417ee8e9.svg";
export { ForwardRef as ReactComponent };